// @core/api/endpoints/document/list_document_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDocumentTypesResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List document types
 * Returns all registered document types, optionally filtered by product.
 */
export async function ListDocumentTypes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDocumentTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-types`;
  const requestOptions = options;
  return client.get<ListDocumentTypesResponse>(requestPath, { ...requestOptions, params });
}
